// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAxios from 'vue-axios'
import axios from 'axios'
import tool from "./utils/index"
import Com from "@/components";
Vue.use(Com);
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
Vue.prototype.$tool = tool;
/** 加载样式 */
import './style/index.less'
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
import VueScroll from 'vue-scroll';
Vue.use(VueScroll);
//注册element
// eslint-disable no-new
Vue.use(elementUI)
// 引入videojs
import videojs from "video.js";
import "video.js/dist/video-js.css";
Vue.prototype.$video = videojs;
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(vueSwiper);
// 引入和风天气图标
import 'qweather-icons/font/qweather-icons.css'
// Vue.use(axios);
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
// 适配flex
import '@/common/flexible.js';
if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
  window.location.href = "https://www.zgyvrqj.com/mobile"
}
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js